// extracted by mini-css-extract-plugin
module.exports = {"container":"gallery-module--container--1Lejy","carouselContainer":"gallery-module--carouselContainer--KUOJa"};